module.exports = _;


/*****************
 ** WEBPACK FOOTER
 ** external "_"
 ** module id = 3
 ** module chunks = 0
 **/